// extracted by mini-css-extract-plugin
export default {"main":"_0sivI","photos":"Q5Syp","text":"vYrEf","section":"gTo6P","error":"dq+v5","picture":"_0oTVd"};